export const STANDARD_STALE_TIME = 1000 * 60 * 10;
